import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { dtcListState } from './states';
import removeIcon from './assets/remove-icon.png';
import { StyledButton } from './components/shared/StyledButton';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import './DtcList.css';
import { getDTCListWithQuery } from './services/DTCService';

export const DtcList = () => {

    const [dtcs, setDtcs] = useRecoilState(dtcListState);
    const [list, setList] = useState<string[]>([]);
    const [getDTCsLoading, setGetDTCsLoading] = useState<boolean>(false);

    const removeDtc = (e: React.MouseEvent<HTMLButtonElement>, id: number) => {
        e.preventDefault();
        setDtcs(dtcs?.filter(d => d.id !== id));
    }

    const queryDTCList = async (query: string) => {
        if (!query) return;

        try {
            setGetDTCsLoading(true);
            getDTCListWithQuery(query)
            .then(resp => {
                let DTCListValues = resp.data
                let DTCList = DTCListValues?.dtcs?.map(dtcItem => dtcItem.dtc)
                setList(DTCList ?? []);
            })
        } catch (error) {
            console.error("Error fetching autocomplete options:", error);
        } finally {
            setGetDTCsLoading(false);
        }
    };

    return <>

        <TransitionGroup className="list">
            {dtcs?.map((d) => (
                <CSSTransition key={d.id} timeout={350} classNames="item">
                    <div key={d.id} className="list-item">
                        <div className="list-dropdown">
                            <label htmlFor="dropdown">DTC:</label>
                            <Autocomplete
                                id="dropdown"
                                freeSolo
                                options={list}
                                onInputChange={(event, newInputValue, reason) => {
                                    queryDTCList(newInputValue);
                                    setDtcs(dtcs?.map(i => i.id === d.id ? { ...i, dtc: newInputValue } : i));
                                }}
                                renderInput={(params) => (<TextField {...params} sx={{backgroundColor: 'white'}} />)}
                                sx={{
                                    '& .MuiOutlinedInput-root' : {
                                        padding: '2px',
                                        fontSize: 18
                                    }
                                }}
                                loading={getDTCsLoading}
                            />
                        </div>
                        <div style={{ paddingTop: '16px' }}>
                            <StyledButton
                                backgroundColor='#2C323D'
                                onClick={(e => removeDtc(e, d.id))}
                                buttonText={'Remove DTC'}
                                image={<img src={removeIcon} alt="Plus Icon" className="remove-icon" />} />
                        </div>
                    </div>
                </CSSTransition>
            ))}
        </TransitionGroup>
    </>
}

